<div class="intro" style="height: 70vh;">
  <div class="row">
    <div class="col-xl-2 col-lg-3 col-md-4 hidden-sm hidden-xs">
      <i class="fa fa-briefcase fa-2x" aria-hidden="true"></i>
      <h2 class="type">Business</h2>
      <p>A license, permit or certification required by State G.S./Federal government for operation of business in the state</p>
    </div>
    <div class="col-xl-2 col-lg-3 col-md-4 hidden-sm hidden-xs">
        <i class="fa fa-address-card-o fa-2x" aria-hidden="true"></i>
        <h2 class="type">Occupational</h2>
        <p>A license, permit or certification required by State G.S./Federal government for performing an occupation in state.</p>
    </div>
    <div class="col-xl-2 col-lg-3 col-md-4 hidden-sm hidden-xs">
        <i class="fa fa-camera-retro fa-2x" aria-hidden="true"></i>
        <h2 class="type">Privilege</h2>
        <p>A license issued by the Department of Revenue required by State G.S. before a person may engage in a business, trade or profession for which a license is required.</p>
    </div>
  </div>
  <div class="col-xl-6 col-lg-9 col-md-12" style="text-align: center;">
    <a [routerLink]="['/license']"><button class="btn btn-outline-light btn-lg">Get started!</button></a>
  </div>  
</div>
<pm-footer></pm-footer>